import { option } from 'fp-ts';
import { SecondaryDestructiveButton } from 'ui/button';
import { useCatalogContext } from 'modules/catalog/catalogSelector';
import { useCatalogSelectionContext } from './contexts/CatalogSelectionContext';
import { useCatalogPreviewContext } from './contexts/CatalogPreviewContext';
import { useCatInSegQueryBuilderV2FeatureFlag } from './hooks/useCatInSegQueryBuilderV2FeatureFlag';
import { useTranslation } from '../../hooks';
import { useCatalogQueryContext } from '../../contexts/catalogQuery';

export const ResetButton = () => {
  const { t } = useTranslation();
  const { change, changeFieldDetails } = useCatalogContext();
  const { isEnabled, update } = useCatalogSelectionContext();
  const { closePreview } = useCatalogPreviewContext();
  const isFeatureFlagged = useCatInSegQueryBuilderV2FeatureFlag();
  const { resetCatalogQuery } = useCatalogQueryContext();

  const onReset = () => {
    change(option.none);
    changeFieldDetails(option.none);
    if (isFeatureFlagged) resetCatalogQuery();
    update(false);
    closePreview();
  };

  if (!isEnabled) return null;

  return (
    <SecondaryDestructiveButton onClick={onReset}>
      {t('catalogQuery.reset')}
    </SecondaryDestructiveButton>
  );
};
